export const availabilityPolicy = {
  cutoffDay: Number(process.env.REACT_APP_DRIVER_AVAILABILITY_CUTOFF_DAY || 5),
  cutoffTime: process.env.REACT_APP_DRIVER_AVAILABILITY_CUTOFF_TIME || '23:59',
  timeZone: 'Europe/Warsaw',
};

export function polishClock(now = new Date()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(now).map(part => [part.type, part.value]));
  return { day: `${parts.year}-${parts.month}-${parts.day}`, time: `${parts.hour}:${parts.minute}` };
}
export function addDays(day, count) {
  const value = new Date(`${day}T12:00:00Z`); value.setUTCDate(value.getUTCDate() + count);
  return value.toISOString().slice(0, 10);
}
export function monday(day) {
  return addDays(day, -((new Date(`${day}T12:00:00Z`).getUTCDay() + 6) % 7));
}
export function formatDay(day, options = { weekday: 'long', day: 'numeric', month: 'long' }, locale = 'pl') {
  return new Intl.DateTimeFormat({ pl: 'pl-PL', en: 'en-GB', de: 'de-DE' }[locale] || 'pl-PL', { ...options, timeZone: 'UTC' }).format(new Date(`${day}T12:00:00Z`));
}
export function editingWindow(day, now = new Date(), policy = availabilityPolicy) {
  // Invalid configuration fails closed rather than silently extending a deadline.
  if (!Number.isInteger(policy.cutoffDay) || policy.cutoffDay < 1 || policy.cutoffDay > 7 || !/^([01]\d|2[0-3]):[0-5]\d$/.test(policy.cutoffTime)) {
    return { editable: false, message: 'Edycja jest niedostępna. Skontaktuj się z dyspozytorem.', deadline: null };
  }
  const deadline = addDays(monday(day), policy.cutoffDay - 8);
  const clock = polishClock(now);
  // The deadline minute is included. Friday 23:59 becomes locked at Saturday 00:00.
  const editable = `${clock.day} ${clock.time}` <= `${deadline} ${policy.cutoffTime}`;
  const nextWeek = addDays(monday(clock.day), 7);
  const nextDeadline = addDays(nextWeek, policy.cutoffDay - 8);
  const openWeek = `${clock.day} ${clock.time}` <= `${nextDeadline} ${policy.cutoffTime}` ? nextWeek : addDays(nextWeek, 7);
  if (monday(day) > openWeek) {
    return { editable: false, reason: 'future', deadline,
      message: `Deklaracje na ten tydzień nie są jeszcze otwarte. Możesz teraz uzupełnić tydzień od ${formatDay(openWeek)}. Dalsze terminy uzgodnij z biurem.` };
  }
  const stamp = `${formatDay(deadline)} o ${policy.cutoffTime}`;
  return { editable, deadline, time: policy.cutoffTime,
    message: editable ? `Możesz zmieniać dostępność do: ${stamp} (czas polski).`
      : `Plan na ten tydzień jest już układany. Edycja dostępności została zamknięta: ${stamp}. Jeśli Twoje plany się zmieniły, skontaktuj się z dyspozytorem.` };
}

export function demoTrips(today) {
  const common = { car: 'SP1', model: 'Mercedes Sprinter', registration: 'KR DEMO', num_passengers: 12, project: 'Grupa turystyczna · przykład', group_lang: 'PL', supervisor: 'Dyspozytor · przykład', project_notes: 'Przykładowe uwagi biura do całego projektu.' };
  const definitions = [
    [0, '09:30', '10:15', 'Kraków → Balice', 'Hotel przy Rynku', 'Kraków Airport', 'Odbiór przy wejściu głównym. Grupa ma 12 dużych walizek.'],
    [0, '16:30', '17:15', 'Balice → Kraków', 'Kraków Airport', 'Hotel przy Rynku', 'Sprawdź tablicę przylotów przed podjazdem.'],
    [1, '07:15', '13:00', 'Kraków → Wieliczka → Kraków', 'Hotel przy Rynku', 'Hotel przy Rynku', 'Postój w Wieliczce. Godzinę powrotu ustal z pilotem.'],
    [1, '20:00', '01:00', 'Kraków → Warszawa', 'Dworzec Kraków Główny', 'Warszawa Centralna', 'Kurs kończy się po północy.'],
    [-1, '06:30', '08:00', 'Kraków → Balice', 'Hotel przy Rynku', 'Kraków Airport', ''],
    [-3, '14:00', '15:30', 'Balice → Kraków', 'Kraków Airport', 'Hotel przy Rynku', ''],
    [-5, '08:00', '17:00', 'Kraków → Zakopane → Kraków', 'Hotel przy Rynku', 'Hotel przy Rynku', ''],
    [-12, '09:00', '16:00', 'Kraków → Wieliczka → Kraków', 'Hotel przy Rynku', 'Hotel przy Rynku', ''],
  ];
  const address = place => ({ 'Hotel przy Rynku': 'Rynek Główny, Kraków', 'Kraków Airport': 'Kapitana M. Medweckiego 1, Balice', 'Dworzec Kraków Główny': 'Pawia 5, Kraków', 'Warszawa Centralna': 'Aleje Jerozolimskie 54, Warszawa' })[place];
  return definitions.map(([offset, start, end, title, from, to, notes], index) => ({
    ...common, id: `demo-${index}`, departure_date: addDays(today, offset), arrival_date: addDays(today, offset + (end < start ? 1 : 0)),
    departure_time: start, arrival_time: end, tweet: title, departure_meta: from, arrival_meta: to,
    departure_address: address(from), arrival_address: address(to), notes,
  }));
}
